import styles from './guidPickup.module.css';
import RadioButtons from '../../../radiobutton/RadioButtons';
import CharCount from '../../../charCount/CharCount';
import { useState } from 'react';

const GuidPickup = ({ guidData, setGuidData }) => {
    // const [meetup, setMeetup] = useState({ name: '', location: '' });
    // const [dragIndex, setDragIndex] = useState(null);
    // const mapUrlPattern = /^https?:\/\/(?:www\.)?maps\.app\.goo\.gl\/([A-Za-z0-9_-]{11,17})(?:[\/?].*)?$/i;
    // function addMeetup() {
    //     if (meetup.name.trim() === '') {
    //         alert('Please enter the meetup name');
    //         return;
    //     }

    //     if (meetup.location.trim() === '') {
    //         alert('Please enter the meetup location');
    //         return;
    //     }

    //     if (!mapUrlPattern.test(meetup.location)) {
    //         alert('Enter proper map location URL');
    //         return;
    //     }

    //     setGuidData((prevState) => ({
    //         ...prevState,
    //         meetupPoint: [...(prevState.meetupPoint || []), meetup]
    //     }));

    //     setMeetup({ name: '', location: '' });
    // }

    // const onDragStart = (index) => {
    //     setDragIndex(index);
    // };

    // const onDropMeetup = (dropIndex) => {
    //     if (dragIndex === null || dragIndex === dropIndex) return;
    //     const updatedMeetupLocation = [...guidData.meetupPoint];
    //     const draggedItem = updatedMeetupLocation[dragIndex];
    //     updatedMeetupLocation.splice(dragIndex, 1);
    //     updatedMeetupLocation.splice(dropIndex, 0, draggedItem);
    //     setGuidData((prev) => ({
    //         ...prev,
    //         meetupPoint: updatedMeetupLocation
    //     }));
    // };

    // const removeMeetUp = (text) => {
    //     setGuidData((prev) => ({
    //         ...prev,
    //         meetupPoint: prev.meetupPoint.filter((item) => item.name !== text.name)
    //     }));
    // };

    return (
        <div>
            <h2 className={styles.orgPackUpH2}>Pickup</h2>
            <div className={styles.orgPackUpSecDiv}>
                <RadioButtons
                    label={'Pickup'}
                    name={'pickup'}
                    value={guidData.pickup}
                    onChange={(value) => {
                        setGuidData((prev) => ({
                            ...prev,
                            pickup: value
                        }));
                    }}
                />
                {guidData.pickup && (
                    <>
                        <div className='itineraryInDiv custom'>
                            <label className={styles.priceLabel}>Pickup Comment</label>
                            <div className={styles.priceInputDiv}>
                                <input
                                    value={guidData.pickupComment || ''}
                                    type='text'
                                    name='pickuplocation'
                                    onChange={(event) =>
                                        setGuidData((prev) => ({
                                            ...prev,
                                            pickupComment: event.target.value
                                        }))
                                    }
                                    placeholder={`Pick from around 5 km of location`}
                                    className={styles.priceInput}
                                />
                                <CharCount
                                    string={guidData.pickupComment ? String(guidData.pickupComment) : ''}
                                    min={2}
                                    limit={50}
                                />
                            </div>
                        </div>
                        {/* <div className={styles.priceMeetUpInDiv}>
                            <label className={styles.priceLabel}>Meetup Point</label>
                            <div className='itineraryDiv1'>
                                <input
                                    type='text'
                                    name='name'
                                    onChange={(e) =>
                                        setMeetup((prev) => ({
                                            ...prev,
                                            [e.target.name]: e.target.value
                                        }))
                                    }
                                    placeholder='Ex- Indiranagar Bus stop (9:00 PM), Enter and press Add Pickup to add'
                                    value={meetup.name}
                                    className='nestedTagInput'
                                    // onKeyDown={(e) => {
                                    //     if (e.key === 'Enter') {
                                    //         addPickup();
                                    //     }
                                    // }}
                                ></input>
                                <CharCount string={meetup.name} min={4} limit={30} />
                                <div className='itineraryInputDiv'>
                                    <input
                                        type='text'
                                        name='location'
                                        onChange={(e) =>
                                            setMeetup((prev) => ({
                                                ...prev,
                                                [e.target.name]: e.target.value
                                            }))
                                        }
                                        placeholder='Google location'
                                        value={meetup.location}
                                        className='nestedTagInput'
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                addMeetup();
                                            }
                                        }}
                                    ></input>
                                    <button type='button' onClick={addMeetup} className='nestedTagOkBtn blueBtn'>
                                        Add Meetup
                                    </button>
                                </div>
                            </div>
                        </div> */}
                    </>
                )}
                {/* {guidData?.meetupPoint?.length > 0 && (
                    <div className='tagContainer'>
                        <div className='tagOutDiv'>
                            {guidData?.meetupPoint.map((text, index) => {
                                return (
                                    <div
                                        key={index}
                                        draggable
                                        onDrag={() => onDragStart(index)}
                                        onDragOver={(event) => event.preventDefault()}
                                        onDrop={() => onDropMeetup(index)}
                                        className='tagDiv'
                                    >
                                        <p className='tagP'>{text.name}</p>
                                        <button
                                            style={{ cursor: 'pointer' }}
                                            className='tagButton'
                                            onClick={(e) => removeMeetUp(text)}
                                        >
                                            X
                                        </button>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                )} */}
            </div>
        </div>
    );
};

export default GuidPickup;
